'use strict';

// Promise.prototype.finally is stage 3, a possible candidate for ES2018
if (typeof Promise === 'function') {
  require('promise.prototype.finally/shim')(); // eslint-disable-line global-require
}

require('array.prototype.flatten/shim')();
require('array.prototype.flatmap/shim')();



//////////////////
// WEBPACK FOOTER
// ./~/airbnb-js-shims/target/es2018.js
// module id = 252
// module chunks = 35783957827783 172322841747965